












































































import Vue from 'vue'
import axios from 'axios'
import { setDocumentTitle } from '@/util'

interface ActivityItem {
  id: string
  name: string
  activity_time: string
  status: number //活动状态：0=未开始 1=进行中 2=已结束
}

const PULL_THRESHOLD = 60
const PAGE_SIZE = 10

function computeStatus(endTime: string): 'ongoing' | 'finished' {
  const parts = endTime.split('.')
  if (parts.length !== 3) return 'finished'
  const end = new Date(+parts[0], +parts[1] - 1, +parts[2], 23, 59, 59)
  return Date.now() <= end.getTime() ? 'ongoing' : 'finished'
}

export default Vue.extend({
  name: 'FullGiftList',

  data() {
    return {
      list: [] as ActivityItem[],
      loading: false,
      loadingMore: false,
      hasError: false,
      noMore: false,
      page: 1,
      pullIndicatorHeight: 0,
      PULL_THRESHOLD,
      // 触摸状态（不需要响应式，用普通属性）
    }
  },

  computed: {
    scrollEl(): HTMLElement {
      return this.$refs.scrollEl as HTMLElement
    },
  },

  async mounted() {
    setDocumentTitle('直播满赠')
    const el = this.scrollEl
    el.addEventListener('touchstart', this._onTouchStart as EventListener, {
      passive: true,
    })
    el.addEventListener('touchmove', this._onTouchMove as EventListener, {
      passive: false,
    })
    el.addEventListener('touchend', this._onTouchEnd as EventListener, {
      passive: true,
    })
    await this.loadList(true)
  },

  beforeDestroy() {
    const el = this.scrollEl
    el.removeEventListener('touchstart', this._onTouchStart as EventListener)
    el.removeEventListener('touchmove', this._onTouchMove as EventListener)
    el.removeEventListener('touchend', this._onTouchEnd as EventListener)
  },

  methods: {
    async loadList(reset: boolean) {
      if (reset) {
        this.page = 1
        this.noMore = false
        this.hasError = false
        this.loading = true
      } else {
        if (this.loadingMore || this.noMore) return
        this.loadingMore = true
      }

      try {
        const {
          data: { list },
        } = await this.$axios.get(
          '/api/activity/fullGift/fullGift/activityList',
          {
            params: { page: this.page, limit: PAGE_SIZE },
          }
        )
        this.list = reset ? list : [...this.list, ...list]
        if (list.length < PAGE_SIZE) this.noMore = true
        else this.page++
      } catch {
        if (reset) {
          this.list = []
          this.noMore = true
        } else {
          this.hasError = true
        }
      } finally {
        this.loading = false
        this.loadingMore = false
      }
    },

    async refresh() {
      await this.loadList(true)
    },

    onScroll() {
      const el = this.scrollEl
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 120) {
        this.loadList(false)
      }
    },

    _onTouchStart(e: TouchEvent) {
      if (this.scrollEl.scrollTop === 0) {
        ;(this as any)._touchStartY = e.touches[0].clientY
        ;(this as any)._isPullingDown = true
      }
    },

    _onTouchMove(e: TouchEvent) {
      if (!(this as any)._isPullingDown) return
      const diff = e.touches[0].clientY - (this as any)._touchStartY
      if (diff > 0) {
        e.preventDefault()
        this.pullIndicatorHeight = Math.min(diff * 0.4, 80)
      }
    },

    _onTouchEnd() {
      if (this.pullIndicatorHeight >= PULL_THRESHOLD) this.refresh()
      this.pullIndicatorHeight = 0
      ;(this as any)._isPullingDown = false
    },

    goBack() {
      this.$router.back()
    },

    goDetail(item: ActivityItem) {
      this.$router.push({
        path: '/fullGift/activityDetail',
        query: { id: item.id },
      })
    },
  },
})
